import React, { forwardRef } from 'react';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';


const useStyles = makeStyles(() => ({
  listbox: {
    '& li:last-child': {
      display: 'none',
    },
  },
  verySmallInput: {
    '& .MuiOutlinedInput-root': {
      height: 32,
      fontSize: '0.875rem',
      padding: 0,
      '& .MuiOutlinedInput-input': {
        margin: '-2px',
      },
    },
  },
  verySmallListbox: {
    '& li': {
      minHeight: 28,
      fontSize: '0.8rem',
      padding: '2px 8px',
    },
  },
}));

const emptyOption = { label: undefined, value: undefined };

const AutocompleteWrapper = forwardRef(({ error = false, fixEmptyWarn = false, multiple = false, size = 'small', ...props }, ref) => {
  const classes = useStyles();
  const placeholder = props.placeholder || (props.options && props.options[0]?.label ?
    `Ej: ${props.options[0].label}` :
    'No hay opciones disponibles');

  const propsToUse = props.clearable ? props : { ...props, disableClearable: true };
  delete propsToUse['clearable'];

  const isVerySmall = size === 'very-small';

  const userClasses = propsToUse.classes || {};
  const mergedClasses = {
    ...userClasses,
    listbox: clsx(userClasses.listbox, fixEmptyWarn && classes.listbox, isVerySmall && classes.verySmallListbox),
  };
  delete propsToUse.classes;

  return <Autocomplete
    ref={ref}
    getOptionLabel={option => option.label || '' }
    renderInput={params =>
      <TextField
        {...params}
        error={error}
        placeholder={placeholder}
        variant="outlined"
        InputLabelProps={{ disableAnimation: true }}
        className={isVerySmall ? classes.verySmallInput : undefined}
        color="secondary"
      />
    }
    size={isVerySmall ? 'small' : size}
    multiple={multiple}
    noOptionsText="No hay opciones"
    classes={mergedClasses}
    {...propsToUse}
    options={fixEmptyWarn ? [ ...propsToUse.options, emptyOption ] : propsToUse.options}
  />;
});

AutocompleteWrapper.propTypes = {
  error: PropTypes.bool,
  value: PropTypes.oneOfType([ PropTypes.array, PropTypes.object ]),
  placeholder: PropTypes.string,
  options: PropTypes.array,
  clearable: PropTypes.bool,
  fixEmptyWarn: PropTypes.bool,
  multiple: PropTypes.bool,
  size: PropTypes.oneOf([ 'small', 'medium', 'very-small' ]),
};


export { AutocompleteWrapper } ;